<template>
  <div class="product"
    :class="{noCategory: !productCategory.filter(x => x.id !== '').length}"
    :data-category="categoryDepth">
    <!-- product category -->
    <div v-if="productCategory.filter(x => x.id !== '').length" id="productCategory" class="category">
      <div class="categoryBox" ref="category">
        <button type="button"
          v-for="cate in productCategory.filter(x => x.id !== '')"
          :key="cate.id"
          :class="{active: cate.id === category}"
          :style="cate.id === category && { ...skinStyle('productActivate', 'border-color') }"
          @click="setCategory(cate.id)">
          <i v-if="cate.icon" class="ico"><img :src="cate.icon" alt=""></i>
          {{cate.label[lang]}}
        </button>
      </div>
      <div v-if="subCategory && subCategory.length" class="subCategory">
        <button type="button"
          :class="{active: !subCategory.find(x => x.id === category2)}"
          @click="setCategory(category)">
          <span :style="!subCategory.find(x => x.id === category2) && { ...skinStyle('productActivate', 'border-color') }">{{locale.all}}</span>
        </button>
        <button type="button"
          v-for="cate in subCategory"
          :key="cate.id"
          :class="{active: cate.id === category2}"
           @click="setSubCategory(cate.id)">
           <i v-if="cate.icon" class="ico"><img :src="cate.icon" alt=""></i>
           <span :style="cate.id === category2 && { ...skinStyle('productActivate', 'border-color') }">{{cate.label[lang]}}</span>
        </button>
      </div>
      <div v-if="subCategory2 && subCategory2.length" class="subCategory">
        <button type="button"
          :class="{active: !subCategory2.find(x => x.id === category3)}"
          @click="setCategory2(category2)">
          <span :style="!subCategory2.find(x => x.id === category3) && { ...skinStyle('productActivate', 'border-color') }">{{locale.all}}</span>
        </button>
        <button type="button"
          v-for="cate in subCategory2"
          :key="cate.id"
          :class="{active: cate.id === category3}"
           @click="setSubCategory2(cate.id)">
           <i v-if="cate.icon" class="ico"><img :src="cate.icon" alt=""></i>
           <span :style="cate.id === category3 && { ...skinStyle('productActivate', 'border-color') }">{{cate.label[lang]}}</span>
        </button>
      </div>
    </div>
    <!-- //product category -->
    <!-- category slider -->
    <Carousel
      v-if="categoryImage && categoryImage.length"
      :autoplay="true"
      :autoplayTimeout="3000"
      :loop="true"
      :perPage="1"
      :mouseDrag="true"
      :paginationPadding="4"
      :paginationActiveColor="'rgba(0,0,0,0.4)'"
      :paginationColor="'rgba(0,0,0,0.2)'"
      class="categoryImage">
      <Slide v-for="(slide, index) in categoryImage" :key="index" class="carouselImg">
        <img v-if="slide" :src="slide" alt="" />
      </Slide>
    </Carousel>
    <!-- //category slider -->
    <!-- place -->
    <div v-if="placeList && placeList.length" class="places">
      {{locale.place}}
      <select
        v-model="productPlace"
        class="input"
        @change="setPlace(productPlace)">
        <option
          v-for="(item, index) in placeList"
          :key="index"
          :value="index.toString()">
          {{item[lang]}}
        </option>
      </select>
    </div>
    <!-- //place -->
    <!-- product list -->
    <ProductList
      :lang="lang"
      :list="product"
      :loadData="loadData"
      :manageList="manageProduct"
      :viewType="viewType"
      :locale="locale"
      :roomKey="roomKey"
      :place="placeList ? placeList[productPlace] : null"
      :activeSort="activeSort"
      :displaySort="displaySort"
      :sortby="sortby"
      @setViewType="changeViewType"
      @setDetail="setDetail"
      @setSortby="setSortby" />
    <!-- //product list -->
    <div class="layer placeLayer" v-if="placeLayer">
      <div class="inner">
        <h2 class="layerTitle">{{locale.place_select}}</h2>
        <div class="placeList">
          <div v-for="(item, index) in placeList"
            :key="index" class="checkbox radio">
            <input type="radio" :id="`product_place_${index}`" @change="setPlace(index)">
            <label :for="`product_place_${index}`" class="btn btnWhite btnFull">{{item[lang]}}</label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="productDetail"
      id="productDetailInfo"
      @click.stop="gotoProduct($event)">
      <div class="pageWrap">
      <Page
        :id="productDetail"
        :locale="locale"
        :lang="lang"
        :responsive="responsive"
        :translateType="translateType"
        :guestType="guestType"
        @destroy="productDetail = null" />
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import ProductList from '@/components/Product/ProductList.vue'
import Page from '@/views/Page.vue'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'Product',
  props: [
    'lang',
    'locale',
    'roomKey',
    'responsive',
    'translateType',
    'productId',
    'guestType'
  ],
  components: {
    Carousel,
    Slide,
    ProductList,
    Page
  },
  computed: {
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    manageProduct () {
      return this.$store.getters['product/getManageProduct']
    },
    product () {
      const category = this.category
      const order = Array.isArray(this.productOrder) ? this.productOrder : category === '' ? this.productOrder.unCategorized : this.productOrder[category] // 순서변경 데이터 (순서만 관여)
      const orderIds = order ? order.map(x => x.id) : []
      const items = this.productList // 모든 상품 데이터
      const itemsIds = items.map(x => x.id)
      const exist = order ? order.filter(x => itemsIds.includes(x.id)) : []
      const added = items ? items.filter(x => !orderIds.includes(x.id)) : []
      const ordered = function () {
        let result = []
        exist.forEach(function (item) {
          result.push(items.find(x => x.id === item.id))
        })
        return result
      }
      /**
       * 순서설정 이후에 추가한 상품이
       * 가장 앞으로 쌓이고
       * 순서설정된 아이템들이 정렬
       * !!!! isSort인 경우 순서설정 무시하고 소팅
       */
      const orderList = added.concat(ordered()).filter(x => validItemData(x))
      const category2 = this.category2 // 2depth category id
      const category3 = this.category3 // 3depth category id
      const cate1 = this.productCategory.find(x => x.id === category) // 2depth category data
      const cate2 = cate1 && cate1.children && cate1.children.find(x => x.id === category2) // 3depth category data(arr)
      const guestType = this.guestType ? this.guestType.id : null
      const defaultGuestType = this.guestType || null
      const isSort = this.activeSort
      const sortby = this.sortby
      const locale = this.$route.params.ln
      const deduplication = isSort
        ? sorting(items.filter(x => validItemData(x)), sortby, locale)
        : orderList.reduce(function (acc, current) {
          if (acc.findIndex(({ id }) => id === current.id) === -1) {
            acc.push(current)
          }
          return acc
        }, [])
      /**
       * 유효한 상품아이템인지 검사
       * 1. 서비스중
       * 2. 전송코드 존재
       * 3. 금액 존재
       */
      function validItemData (data) {
        return data.service && data.submitTo !== '' && regExp.replaceAllEmpty(data.info.price).length
      }
      function sorting (arr, sortby, lang) {
        const getSortKey = function (info, sortby) {
          const sortKey = sortby.split('_')[0]
          const key = sortKey.includes('name')
            ? info.name
              ? regExp.replaceAllEmpty(info.name[lang])
              : ''
            : sortKey.includes('price')
              ? parseFloat(info.price)
              : ''
          return key
        }
        const order = sortby.split('_')[1] === 'asc' ? -1 : 1
        return arr.sort(function (a, b) {
          const sortA = getSortKey(a.info, sortby)
          const sortB = getSortKey(b.info, sortby)
          return sortA > sortB ? (-1 * order) : sortA < sortB ? (1 * order) : 0
        })
      }
      // 카테고리 필터
      return deduplication.filter(x => {
        if (category === '') { // all
          return x
        } else {
          if (category2 === '') { // category1 all
            // return x.info.category === category
            return x.category.includes(category) || (cate1 && cate1.childrenIds && x.category.filter(c => cate1.childrenIds.includes(c)).length > 0)
          } else {
            if (category3 === '') { // category2 all
              // return x.info.category === category && x.info.category2 === category2
              return x.category.includes(category2) || (cate2 && cate2.childrenIds && x.category.filter(c => cate2.childrenIds.includes(c)).length > 0)
            } else {
              // return x.info.category === category && x.info.category2 === category2 && x.info.category3 === category3
              return x.category.includes(category3)
            }
          }
        }
      }).map(x => {
        const guestItem = x.guestType
          ? x.guestType[0].setDefault
            ? defaultGuestType
            : x.guestType.find(g => g.id === guestType)
          : defaultGuestType
        return {
          ...x,
          ...guestItem && {
            guestType: {
              ...guestItem,
              name: this.guestType.name
            }
          }
        }
      }).filter(x => {
        return !(x.guestType && x.guestType.hide)
      })
    },
    categoryImage () {
      const id = this.category
      const id2 = this.category2
      const id3 = this.category3
      const category = this.productCategory.find(x => x.id === id)
      let result = null
      if (category) {
        if (id2 !== '') {
          if (id3 !== '') {
            if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).children && category.children.find(c => c.id === id2).children.find(t => t.id === id3) && category.children.find(c => c.id === id2).children.find(t => t.id === id3).image.length) {
              result = category.children.find(c => c.id === id2).children.find(t => t.id === id3).image
            } else {
              if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).image.length) {
                result = category.children.find(c => c.id === id2).image
              } else {
                result = category.image
              }
            }
          } else {
            if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).image.length) {
              result = category.children.find(c => c.id === id2).image
            } else {
              result = category.image
            }
          }
        } else {
          result = category.image
        }
      }
      return result
      // return category
      //   ? id2 !== ''
      //     ? category.children.find(c => c.id === id2).image.length
      //       ? category.children.find(c => c.id === id2).image
      //       : category.image
      //     : category.image
      // : null
    },
    subCategory () {
      const category = this.category
      const list = this.productCategory
      return (list.find(x => x.id === category) && list.find(x => x.id === category).children) || []
    },
    subCategory2 () {
      const category = this.category2
      const list = this.subCategory
      return (list.find(x => x.id === category) && list.find(x => x.id === category).children) || []
    },
    categoryDepth () {
      let depth = 0
      if (this.productCategory.length) {
        depth += 1
      }
      if (this.subCategory.length) {
        depth += 1
      }
      if (this.subCategory2.length) {
        depth += 1
      }
      return depth
    }
  },
  watch: {
    '$route' (to, from, next) {
      if ((to.params.productId !== from.params.productId) || to.params.category !== from.params.category) {
        this.init(this.sortby)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.productDetail && (
      to.name !== 'cart' &&
      to.name !== 'payment' &&
      to.name !== 'paymentStep' &&
      to.name !== 'page' &&
      to.name !== 'complete')) {
      this.productDetail = null
      next(false)
    } else {
      next()
    }
  },
  created () {
    const authentication = this.$store.state.authentication
    const ota = authentication.k || authentication.site
    const sortby = localStorage.getItem(`sortby_${ota}`)
    this.init(sortby)
    this.sortby = sortby
    window.addEventListener('beforeunload', function () {
      localStorage.removeItem(`sortby_${ota}`)
    })
  },
  data () {
    return {
      loadData: false,
      productCategory: [],
      category: '',
      category2: '',
      category3: '',
      categoryTree: {},
      viewType: '',
      productList: [],
      productOrder: [],
      placeLayer: false,
      placeList: null,
      productPlace: '',
      productDetail: null,
      activeSort: false,
      displaySort: false,
      sortby: 'created' // asc, dec, priceAsc, priceDec, created
    }
  },
  methods: {
    track (title) {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    init (sortby) {
      this.productDetail = null
      this.$store.dispatch('submit/getSubmitCode')
      this.$store.dispatch('product/getManageProduct').then((res) => {
        this.getProduct(sortby).then(() => {
          this.categoryScrollBar()
        })
      })
    },
    changeViewType (type) {
      this.viewType = type
    },
    setDetail (data) {
      this.productDetail = data.page
      this.$route.meta.productItemId = data.detail
    },
    setSortby (data) {
      const authentication = this.$store.state.authentication
      const ota = authentication.k || authentication.site
      this.sortby = data
      localStorage.setItem(`sortby_${ota}`, data)
    },
    gotoProduct (e) {
      if (e.target === e.currentTarget) {
        this.productDetail = null
        this.$router.replace({meta: null})
      }
    },
    async getProductVersion () {
      const productId = this.productId
      const version = await this.$store.dispatch('versionhistory/getLastVersion', { file: `product/item/${productId}.json` })
      const productData = await this.$store.dispatch('versionhistory/getIndexedDb', {
        table: 'product',
        id: productId,
        version: version || 0
      })
      if (!productData || productData === 'diffVersion') {
        const loadFile = await this.$store.dispatch('versionhistory/getFile', { file: `product/item/${productId}.json`, version: version, fileId: productId })
        if (loadFile && loadFile.data) {
          await this.$store.dispatch('product/setProductData', loadFile.data)
          this.$store.dispatch('versionhistory/setIndexedDb', {
            table: 'product',
            id: loadFile.data.id,
            version: loadFile.data.version,
            data: loadFile.data
          })
          return loadFile.data
        } else {
          const loadProduct = await this.$store.dispatch('product/getProduct', productId)
          return loadProduct
        }
      } else {
        await this.$store.dispatch('product/setProductData', productData)
        return productData
      }
    },
    async getProduct (sortby) {
      const setting = await this.$store.dispatch('product/getProductSetting')
      const promotionList = setting && setting.promotion
      const productId = this.productId
      const manageList = this.manageProduct
      const categoryChildrenIds = function (arr) {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            return result.push(x.data.id)
          })
          return result
        }
        return ids(arr)
      }
      function setCategory (arr) {
        return arr.map(x => {
          if (!x.data) {
            x = { data: x }
          }
          if (x.children && x.children.length) {
            return {
              ...x.data,
              children: setCategory(x.children),
              childrenIds: categoryChildrenIds(x.children)
            }
          } else {
            return {
              ...x.data
            }
          }
        })
      }
      this.$store.commit('loading', true)
      return this.getProductVersion().then((res) => {
        this.loadData = true
        if (res) {
          this.track(res.title)
          // 상품 이용장소
          if (res.place && res.placeList.length) {
            this.placeList = res.placeList
            const productId = res.id
            if (localStorage && localStorage.length) {
              for (let i = 0; i < localStorage.length; i++) {
                /**
                 * 이용장소가 기존에 설정했었는지에 따라
                 * 설정 레이어를 초기에 보여주거나 감춤
                 */
                const storage = localStorage.key(i)
                if (storage.includes('place_') && storage.includes(productId)) {
                  this.placeLayer = false
                  this.productPlace = localStorage.getItem(storage)
                  break
                } else {
                  this.placeLayer = true
                }
              }
            }
          }
          const category = (res && res.category && res.category.filter(x => x.id !== '' || (x.data && x.data.id !== ''))) || []
          this.activeSort = res.activeSort
          this.displaySort = res.displaySort
          this.sortby = sortby || res.sortby
          this.viewType = res.viewType || 'grid'
          this.productCategory = setCategory(category)
          this.category = this.$route.params.category
            ? Number(this.$route.params.category)
            : this.productCategory.length
              ? this.productCategory[0].id
              : ''
          this.productList = res.items ? res.items.map(x => {
            const promotionInfo = function (id) { // 프로모션 커스텀 적용 맵핑
              const item = promotionList && promotionList.find(x => x.id === id)
              return item && !item.default
                ? {
                  promotionCustom: !item.default,
                  promotionSize: item.size,
                  promotionIcon: item.icon
                }
                : null
            }
            // 관리상품이나 더이상 해당 관리상품이 존재하지 않는 경우
            if (!(x.manage && x.manageInfo && manageList.find(p => p.pid === x.manageInfo.pId))) {
              delete x.manageInfo
            }
            // 이용가능시간 단일설정 -> 다중설정 맵핑
            const available = {
              ...x.available,
              set: x.available.set.map(t => {
                const time = t.time || (t.timeFrom && t.timeTo && {
                  time: [
                    {
                      from: t.timeFrom,
                      to: t.timeTo
                    }
                  ]
                })
                return {
                  ...t,
                  ...time
                }
              })
            }
            // 카테고리 단일설정 -> 다중설정 맵핑 (info.category에서 category로 이동)
            let category = x.category || []
            if (!x.category) {
              if (x.info.category) {
                category.push(x.info.category)
              }
              if (x.info.category2) {
                category.push(x.info.category2)
              }
              if (x.info.category3) {
                category.push(x.info.category3)
              }
            }
            return {
              ...x,
              available: available,
              category: category,
              info: {
                ...x.info,
                ...x.info.promotion && x.info.promotionCustom && promotionInfo(x.info.promotion)
              }
            }
          }) : []
          this.productOrder = res.order || []
        } else {
          alert(this.locale.alert_system_error)
        }
        this.$store.commit('loading', false)
      })
    },
    setCategory (categoryId) {
      this.category = categoryId
      this.category2 = ''
      this.categoryScrollBar()
      const ln = this.$route.params.ln
      this.$router.replace({
        name: 'productCategory',
        params: {
          productId: this.productId,
          category: categoryId,
          ln: ln
        }
      })
    },
    setCategory2 (categoryId) {
      this.category2 = categoryId
      this.category3 = ''
    },
    setSubCategory (categoryId) {
      this.category2 = categoryId
    },
    setSubCategory2 (categoryId) {
      this.category3 = categoryId
    },
    setPlace (idx) {
      const index = Number(idx)
      const place = this.placeList[index] || null
      const placeName = place ? place[this.lang] : ''
      setTimeout(() => {
        alert(`${this.locale.place}: ${placeName}\n${this.locale.message_place_reselect}`)
      }, 300)
      setTimeout(() => {
        this.placeLayer = false
      }, 600)
      this.productPlace = idx
      localStorage.setItem(`place_${this.productId}`, index)
    },
    getCategoryName (categoryId) {
      const lang = this.lang
      const categories = getCategories(this.productCategory)
      function getCategories (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          result.push(item)
          if (item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j]
              result.push(child)
              if (child.children && child.children.length) {
                for (let k = 0; k < child.children.length; k++) {
                  const tail = child.children[k]
                  result.push(tail)
                }
              }
            }
          }
        }
        return result
      }
      return categories.find(x => x.id === categoryId).label[lang] || 'category'
    },
    categoryScrollBar () {
      const category = this.$refs.category
      if (category) {
        const offset = category.querySelector('.active').offsetLeft
        const width = category.querySelector('.active').offsetWidth / 2
        const screen = document.body.clientWidth / 2
        category.scrollLeft = offset - (screen - width)
      }
    },
    getManageProduct () {
      return this.$store.dispatch('product/getManageProduct')
    }
  }
}
</script>

<style lang="scss" scoped>
.placeLayer {
  .layerTitle {
    padding-right: 0;
    text-align: center;
  }
  .inner {
    align-items: center;
    justify-content: center;
    color: $color-white;
    background: none;
  }
  .placeList {
    width: 100%;
    max-height: 100%;
    border-radius: 4px;
    background-color: $color-white;
    overflow: auto;
    .btn {
      padding: 1em 1em 1em 40px;
      &:before {
        top: 50%;
        left: 1em;
        margin-top: -10px;
      }
    }
    .checkbox {
      display: block;
      margin: 0;
      & + .checkbox .btn {
        border-top: none;
      }
    }
  }
}
.places {
  height: 34px;
  margin-bottom: -34px;
  padding-top: 15px;
  padding-left: 15px;
  font-size: 0.85em;
  .input {
    max-width: 50%;
    width: auto;
    min-height: 0;
    height: 34px;
    padding: 0.4em;
  }
}
.category {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  overflow: hidden;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.15);
  z-index: 8;
  .categoryBox {
    overflow-x: auto;
    white-space: nowrap;
  }
  button {
    position: relative;
    height: 60px;
    padding: 0 30px;
    color: $color-grey;
    .ico {
      display: block;
      width: 24px;
      margin: 0 auto;
      opacity: 0.5;
    }
    &.active {
      font-weight: 700;
      color: $color-dark;
      border-color: $color-primary;
      .ico {
        opacity: 1;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-top: 4px solid $color-white;
        border-top-color: inherit;
      }
    }
  }
  .subCategory {
    overflow: auto;
    font-size: 0.85em;
    white-space: nowrap;
    border-top: 1px solid $color-lgrey2;
    box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    button {
      height: 32px;
      padding-left: 15px;
      padding-right: 15px;
      span {
        position: relative;
        border-color: $color-primary;
      }
      .ico {
        display: inline-block;
        width: 20px;
        margin-right: 4px;
        margin-bottom: 0;
      }
      &.active {
        border-color: $color-primary;
        &:after {
          display: none;
        }
        span:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          height: 1px;
          border-top: 1px solid $color-primary;
          border-color: inherit;
        }
      }
    }
  }
  &.fixed {
    position: fixed;
    button {
      .ico {
        display: inline-block;
        width: 24px;
        margin-bottom: 0;
      }
    }
    .subCategory {
      button {
        .ico {
          width: 20px;
        }
      }
    }
  }
}
.product {
  &[data-category="1"] {
    padding-top: 60px;
  }
  &[data-category="2"] {
    padding-top: 94px;
  }
  &[data-category="3"] {
    padding-top: 126px;
  }
  &.noCategory {
    padding-top: 0;
  }
}
.roomKey .category {
  top: 90px;
}
.scrollDown .roomKey .category {
  top: 50px;
  transition-delay: 0.8s;
}
@media screen and (min-width: 768px) {
  .category {
    top: 0 !important;
    left: 80px;
  }
}
@media screen and (min-width: 800px) {
  .category {
    left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .category {
    left: 240px;
  }
  .places {
    height: 49px;
    margin-bottom: -49px;
    padding-top: 30px;
    padding-left: 30px;
  }
}
.noFrame .category {
  top: 0 !important;
  left: 0 !important;
}
</style>
